import { collection, doc, getDoc, getDocs } from 'firebase/firestore';
import { getFunctions, httpsCallable } from 'firebase/functions';
import app from '../firebase/firebase-app';
import { db } from '../firebase/firebase-config';
import { COLLECTIONS } from '../platform/constants';

const functions = getFunctions(app);

function mapLifecycleError(error) {
  const code = error?.code || '';
  const message = error?.message || '';

  if (code === 'functions/permission-denied') {
    return 'Nimate dovoljenja za to dejanje.';
  }
  if (code === 'functions/unauthenticated') {
    return 'Za to dejanje morate biti prijavljeni.';
  }
  if (code === 'functions/invalid-argument') {
    return message.replace(/^FirebaseError:\s*/i, '') || 'Neveljavni podatki.';
  }
  if (code === 'functions/failed-precondition') {
    return message.replace(/^FirebaseError:\s*/i, '') || 'Dejanje ni dovoljeno.';
  }
  if (code === 'functions/unavailable' || code === 'functions/not-found') {
    return 'Storitev trenutno ni na voljo. Poskusite znova pozneje.';
  }

  return 'Prišlo je do napake. Poskusite znova.';
}

async function invoke(name, payload) {
  try {
    const callable = httpsCallable(functions, name);
    const result = await callable(payload);
    return result.data;
  } catch (error) {
    throw new Error(mapLifecycleError(error));
  }
}

export async function fetchTenantUsersForManagement(tenantId) {
  if (!tenantId) {
    return [];
  }

  const membersSnap = await getDocs(
    collection(db, COLLECTIONS.TENANTS, tenantId, COLLECTIONS.MEMBERS),
  );

  if (membersSnap.empty) {
    return [];
  }

  const rows = await Promise.all(
    membersSnap.docs.map(async (memberDoc) => {
      const membership = memberDoc.data();
      const uid = memberDoc.id;
      const userSnap = await getDoc(doc(db, COLLECTIONS.USERS, uid));
      const profile = userSnap.exists() ? userSnap.data() : {};

      const unitId = Array.isArray(membership.unitIds) && membership.unitIds.length
        ? membership.unitIds[0]
        : profile.unit || '';

      return {
        id: uid,
        email: profile.email || '',
        firstName: profile.firstName || '',
        lastName: profile.lastName || '',
        displayName: profile.displayName || '',
        phone: profile.phone || '',
        jobPosition: membership.jobPosition || profile.jobPosition || '',
        workArea: membership.workArea || profile.workArea || '',
        photoURL: profile.photoURL || '',
        chatColor: profile.chatColor || profile.authorColor || '',
        authorColor: profile.chatColor || profile.authorColor || '',
        role: membership.role || profile.role || 'user',
        unit: unitId,
        membershipStatus: membership.status || 'active',
      };
    }),
  );

  return rows.sort((a, b) => {
    const nameA = `${a.lastName} ${a.firstName}`.trim() || a.email;
    const nameB = `${b.lastName} ${b.firstName}`.trim() || b.email;
    return nameA.localeCompare(nameB, 'sl');
  });
}

export function adminCreateTenantUser(payload) {
  return invoke('adminCreateTenantUser', payload);
}

export function adminUpdateTenantUser(payload) {
  return invoke('adminUpdateTenantUser', payload);
}

export function adminDeleteTenantUser(payload) {
  return invoke('adminDeleteTenantUser', payload);
}
